import React, { Component }  from 'react';
import {connect} from 'react-redux';
import { fetchArranges, fetchArrange, editArrange, newArrange, deleteArrange } from '../../../../actions';



class Arrange extends Component {

    //Initial Rendering
    componentDidMount() {   
        this.props.fetchArranges(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
            this.props.fetchArranges(this.props.patient._id);
        }   
    }

    //Render arrange list

    render() {
        return this.props.arranges.map(item => {
            return (
                <div className='btTag' disabled style={{height:'20px'}}>{item.arrange}</div>
            )
        });   
    }
}

const mapStateToProps = (state) => {
    return { 
        patient : state.selectedPatient,
        arranges : Object.values(state.arranges),
        userId : state.auth.userId
    }
}

export default connect(mapStateToProps, {
    fetchArranges, fetchArrange, editArrange, newArrange, deleteArrange
    })(Arrange);